import { ICommandBase } from "@Quest/cqrs";

export class CreateRevenueAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Revenues.Commands.CreateRevenueAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;

	constructor(workspaceId: number, strategyId: string, revenueId: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = revenueId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Revenues.Commands.CreateRevenueAccountCommandV1, TCh.Domain.Quest';
	}
}
export class DeleteRevenueAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Revenues.Commands.DeleteRevenueAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	constructor(workspaceId: number, strategyId: string, revenueId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = revenueId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Revenues.Commands.DeleteRevenueAccountCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateRevenueAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Revenues.Commands.UpdateRevenueAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;

	constructor(workspaceId: number, strategyId: string, revenueId: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = revenueId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Revenues.Commands.UpdateRevenueAccountCommandV1, TCh.Domain.Quest';
	}
}





